module.exports = __webpack_public_path__ + "static/media/aazady.2025244e.png";